export enum InvestmentRoundingSetting {
  DEFAULT = 'default',
  ROUND_DOWN = 'round-down',
  ROUND_UP = 'round-up',
}
